
import { VListItemAction } from "vuetify/lib";

export default VListItemAction.extend({});
